import { connect } from 'react-redux';
import { State } from 'store/types';
import { sendNewsletter } from 'shared/store/footer/action';
import View from './View';


const mapStateToProps = (state: State) => {
  const { remoteConfig } = state;
  return {
    newsletterEnabled: remoteConfig?.switches.newsletterEnabled,
    region: state.appReducer.region,
  };
};

const mapDispatchToProps = {
  sendNewsletter,
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
